var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69 9.9157H16.31M7.69 9.9157H2.75M7.69 9.9157L11.34 19.9667M7.69 9.9157L10.09 5.9827L10.64 4.9707M16.31 9.9157H21.25M16.31 9.9157L12.66 19.9667M16.31 9.9157L13.91 5.9827L13.344 4.9707M2.75 9.9157C2.75 10.3357 2.829 10.7557 2.986 11.1517C3.198 11.6867 3.628 12.1797 4.486 13.1647L7.953 17.1407C9.35 18.7427 10.048 19.5447 10.876 19.8387C11.0287 19.8927 11.1833 19.9354 11.34 19.9667M2.75 9.9157C2.75 9.4957 2.829 9.0757 2.986 8.6787C3.198 8.1437 3.628 7.6517 4.486 6.6657C4.953 6.1317 5.186 5.8647 5.456 5.6577C5.85742 5.35177 6.3226 5.1402 6.817 5.0387C7.151 4.9707 7.505 4.9707 8.214 4.9707H10.64M11.34 19.9667C11.7758 20.0529 12.2242 20.0529 12.66 19.9667M10.64 4.9707H13.344M21.25 9.9157C21.25 10.3357 21.171 10.7557 21.014 11.1517C20.802 11.6867 20.372 12.1797 19.514 13.1647L16.047 17.1407C14.65 18.7427 13.952 19.5447 13.124 19.8387C12.9726 19.8923 12.8175 19.9351 12.66 19.9667M21.25 9.9157C21.25 9.4957 21.171 9.0757 21.014 8.6787C20.802 8.1437 20.372 7.6517 19.514 6.6657C19.047 6.1317 18.814 5.8647 18.544 5.6577C18.1426 5.35177 17.6774 5.1402 17.183 5.0387C16.849 4.9707 16.495 4.9707 15.786 4.9707H13.344",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgradeIcon.795134f3bfd27e6996c9221db4b36f80.svg";
export { ForwardRef as ReactComponent };